import { Link as RouterLink, useNavigate as useRouterNavigate, useRouterState } from "@tanstack/react-router";
import { isEnglishPath, toEnglishPath } from "@/lib/route-i18n";

/**
 * Drop-in-ersättning för @tanstack/react-router `Link` och `useNavigate`.
 * När besökaren är på en engelsk /en-sida pekas interna länkar automatiskt
 * om till motsvarande engelska sida, så man inte hamnar på svenska mitt i
 * ett flöde. Länkar utan engelsk motsvarighet (guider, kommunsidor) lämnas
 * orörda.
 */
export function useIsEnglishRoute(): boolean {
  return useRouterState({ select: (s) => isEnglishPath(s.location.pathname) });
}

function mapTo(to: unknown, english: boolean): unknown {
  if (!english || typeof to !== "string") return to;
  return toEnglishPath(to);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function Link(props: any) {
  const english = useIsEnglishRoute();
  return <RouterLink {...props} to={mapTo(props.to, english)} />;
}

export function useNavigate() {
  const navigate = useRouterNavigate();
  const english = useIsEnglishRoute();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (opts: any) => {
    if (opts && typeof opts === "object" && "to" in opts) {
      return navigate({ ...opts, to: mapTo(opts.to, english) });
    }
    return navigate(opts);
  };
}
